import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { useSelector, useDispatch } from "react-redux";
import { loginAction } from '../redux/actions/actions';

import TooltipComponent from './tooltip'

import { AiOutlineStar } from "react-icons/ai"
import help_icon from "../assets/help-center-icon.png"
import notification from "../assets/notification.png"
import read_icon from "../assets/read-icon.png"
import eye from "../eye.png"
import { SIGN_OUT } from '../helpers/api';
import isUserLogin from '../helpers/IsUserLogin';

function NavFooter() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const authUser = useSelector((state) => state.authReducer)
    const [showNotify, setShowNotify] = useState(0);


    return (
        <>
            {/* ===================== Mobile Nav-Footer ===================== */}

            <div className='NavFooter py-3'>
                <div className={`d-flex ai-center ${isUserLogin() ? "jc-around":"jc-center"}`}>
                    {
                        isUserLogin() ?
                            <>
                                <div className='favourite-icon'>
                                    <Link to="/favourites">
                                        <AiOutlineStar className='nav_icons favourite_icon me-3' />
                                    </Link>
                                </div>
                                <div className="help-icon">
                                    <Link to="/help-center">
                                        <img src={help_icon} alt="icon" className='img-fluid nav_icons' />
                                    </Link>
                                </div>
                                <div className="notify-icon">
                                    <Notification showNotify={showNotify} setShowNotify={setShowNotify} />
                                </div>
                            </>
                            :
                            <div className="help-icon mx-3">
                                <Link to="/help-center">
                                    <img src={help_icon} alt="icon" className='img-fluid nav_icons' />
                                </Link>
                            </div>
                    }
                    <div className="display-btn">
                        <div className="button diplay">
                            {
                                isUserLogin() ?
                                    <div className="dropdown connect-dropdown">
                                        <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {authUser.username}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <Link className="dropdown-item" to="/wallet">Wallet</Link>
                                            <Link className="dropdown-item" to="/profile">Profile</Link>
                                            <span className="dropdown-item" to="#" onClick={() => { SIGN_OUT(); navigate("/sign-in"); dispatch(loginAction({})) }} style={{ cursor: "pointer" }}>Sign Out</span>
                                        </div>
                                    </div>
                                    :
                                    <div className="connect-dropdown">
                                        <button className="btn" onClick={() => navigate("/sign-in")}> Sign In </button>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function Notification(props) {

    const isMobile = useMediaQuery({ query: '(max-width: 482px)' })

    return (
        <>
            <Link to="#" className='position-relative bell'>
                <div className="dropdown">
                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img src={notification} alt="icon" className={`img-fluid nav_icons ${isMobile ? "mx-1" : "mx-3"}`} />
                    </button>
                    <div className="dropdown-menu" style={{ width: "145%", backgroundColor: "transparent", border: "none" }} aria-labelledby="dropdownMenuButton">
                        <div className='notificaton_sec'>
                            <div className='p-3 notificaton_header'>
                                <h5>Notification</h5>
                            </div>
                            <div className='scroll_notification'>
                                <div className='notifications d-flex jc-between ai-center px-3 py-2'>
                                    <div>
                                        <p className='notifi_head m-0'>Example title notification!</p>
                                        <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                                        <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                                    </div>
                                    <div className='notifi_icon d-flex ai-center d-flex ai-center text-center'>
                                        <img src={read_icon} alt="icon" className='img-fluid' />
                                    </div>
                                </div>
                                <div className='notifications d-flex jc-between ai-center px-3 py-2'>
                                    <div>
                                        <p className='notifi_head m-0'>Example title notification!</p>
                                        <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                                        <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                                    </div>
                                    <div className='notifi_icon d-flex ai-center d-flex ai-center text-center'>
                                        <img src={read_icon} alt="icon" className='img-fluid' />
                                    </div>
                                </div>
                                <div className='notifications d-flex jc-between ai-center px-3 py-2'>
                                    <div>
                                        <p className='notifi_head m-0'>Example title notification!</p>
                                        <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                                        <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                                    </div>
                                    <div className='notifi_icon d-flex ai-center d-flex ai-center text-center'>
                                        <img src={read_icon} alt="icon" className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                            <div className='text-center p-3 notificaton_footer'>
                                <div>
                                    <img src={read_icon} alt="icon" className='img-fluid w-auto h-auto me-1' />
                                    <small>Mark all as read</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Link>
        </>
    )
}

export default NavFooter
